import { ROUTES } from './constants'

/**
 * Navigation utilities for Settings menu integration
 */
export const NavigationUtils = {
  /**
   * Navigate to Settings page with specific tab
   * @param {Function} navigate - React Router navigate function
   * @param {string} tab - Tab name (brands, areas, users)
   */
  navigateToSettingsTab: (navigate, tab) => {
    navigate(`${ROUTES.SETTINGS}?tab=${tab}`)
  },

  /**
   * Get the appropriate back navigation path for Settings tabs
   * @param {string} section - Section name (brands, areas, users)
   * @returns {string} Navigation path
   */
  getSettingsBackPath: (section) => {
    return `${ROUTES.SETTINGS}?tab=${section}`
  },

  /**
   * Navigate back to appropriate Settings tab based on current context
   * @param {Function} navigate - React Router navigate function
   * @param {string} section - Section name (brands, areas, users)
   */
  navigateBackToSettings: (navigate, section) => {
    navigate(NavigationUtils.getSettingsBackPath(section))
  },

  /**
   * Check if current route should use Settings navigation
   * @param {string} pathname - Current pathname
   * @returns {boolean} Whether to use Settings navigation
   */
  shouldUseSettingsNavigation: (pathname) => {
    // Use Settings navigation for management sections
    return pathname.includes('/brands') || 
           pathname.includes('/areas') || 
           pathname.includes('/users')
  },

  /**
   * Get section name from pathname
   * @param {string} pathname - Current pathname
   * @returns {string} Section name or null
   */
  getSectionFromPath: (pathname) => {
    if (pathname.includes('/brands')) return 'brands'
    if (pathname.includes('/areas')) return 'areas'
    if (pathname.includes('/users')) return 'users'
    return null
  }
}
